import React from "react";

const CustomSelect = ({
  value,
  name,
  options = [],
  handleChange,
  onChange, // soporte directo
  label,
  labelClassName = "text-xs font-medium text-cs-dark",
  className = "",
  error,
  holder,
  colorOption,
  ...props
}) => {
  const hasError = Boolean(error);

  const baseSelectClasses = `
    w-full
    h-9
    px-3
    rounded-lg
    text-xs
    border
    outline-none
    bg-cs-bg-alt
    text-cs-dark
    placeholder-cs-muted
    focus:ring-2
    focus:ring-cs-primary/50
    focus:border-cs-primary
    transition-all
  `;

  const itemClassName = `
    ${baseSelectClasses}
    ${hasError ? "border-cs-danger" : "border-cs-border"}
    ${className}
  `;

  const ErrorMessage = () =>
    hasError ? (
      <span className="mt-1 text-[10px] text-cs-danger">{error}</span>
    ) : null;

  const handleOnChange = handleChange || onChange;

  return (
    <div className="flex flex-col w-full py-1 gap-1">
      {label && (
        <label className={labelClassName}>
          {label}
        </label>
      )}

      <select
        name={name}
        value={value ?? ""} // Controlado
        className={itemClassName}
        onChange={handleOnChange}
        style={colorOption ? { background: colorOption } : undefined}
        {...props}
      >
        <option value="">{holder ?? "Select"}</option>
        {options.map((item, index) => (
          <option key={index} value={item.id}>
            {item.name}
          </option>
        ))}
      </select>

      <ErrorMessage />
    </div>
  );
};

export default CustomSelect;
